import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CustomerService } from '../../../resources/auth/customer.service';
import { PermissionService } from '../../../resources/auth/permission.service';
import { Permission } from '../../../resources/models/permission.enum';

@Injectable()
export class ViewCustomerDataGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
    private customerService: CustomerService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const customerId: number = Number(route.params['customerId']);
    return Observable.forkJoin(
      this.permissionService.hasPermission(Permission.VIEW_CUSTOMER_DATA).take(1),
      this.customerService.hasCustomer(customerId).take(1),
    ).map(([hasPermission, hasCustomer]) => {
      return hasPermission && hasCustomer;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routing/permission-guards/view-customer-data.guard.ts